import {switchMap, map, filter, startWith, shareReplay, withLatestFrom} from 'rxjs/operators';
import {copyTradeApi} from '@px/api/copy-trade';
import {authStatus$} from './auth';
import {contract$} from './contract';

export const isTraderSettingSymbol$ = _getIsTraderSettingSymbol$(authStatus$, copyTradeApi.getTraderSetting, contract$);

export function _getIsTraderSettingSymbol$(authStatus$, api$, contract$) {
  return authStatus$.pipe(
    filter((status) => status === 'Login'),
    switchMap(api$),
    map((response) => response.data || []),
    withLatestFrom(contract$),
    map(([symbols, contract]) => !!symbols.find((symbol) => symbol === contract.symbol)),
    startWith(false),
    shareReplay(1)
  );
}
